import model from "../Static Files/Images/HomePage/Model.png";
import airplane from "../Static Files/Images/HomePage/second hero/Aeroplane 64x64.png";
import bestprice from "../Static Files/Images/HomePage/second hero/Best Price 64x64.png";
import employee from "../Static Files/Images/HomePage/second hero/Employee 64x64.png";
import navigation from "../Static Files/Images/HomePage/second hero/Navigation 64x64.png";
import moskva from "../Static Files/Images/HomePage/active tours/moskova_sehir_rehberi.jpg";
import washington from "../Static Files/Images/HomePage/blog/washington-dc.jpg";
import worldicon from "../Static Files/Images/HomePage/active tours/World 32x32.png";
import diversity from "../Static Files/Images/HomePage/about us/Diversity 128x128.png";
import travel from "../Static Files/Images/HomePage/about us/Travel.jpg";
import confidence from "../Static Files/Images/HomePage/about us/Confidence 128x128.png";
import universal from "../Static Files/Images/HomePage/about us/Universal 128x128.png";
import logotransparent from "../Static Files/Images/HomePage/Logo Transparent.png";
import LeftArrowIcon from "../Components/leftArrowIcon";
import RightArrowIcon from "../Components/rightArrowIcon";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { fetchTours } from "../slices/tourSlice";
import { Link } from "react-router-dom";

import "../Static Files/styles/home page/home.css";
import FollowUs from "../Components/followus";
import ImageSlider from "../Components/slider";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import translation from "../locales";
import { fetchBlogs } from "../slices/blogSlice";
import Loading from "../Components/Loading";

const Home = () => {
  const dispatch = useDispatch();
  const { tours, status, error } = useSelector((state) => state.tours);
  const { blogs } = useSelector((state) => state.blogs);

  const [tourList, setTourList] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  const changeLanguage = (newLang) => {
    const newPath = location.pathname.replace(`/${currentLang}`, `/${newLang}`);
    navigate(newPath); // Yeni dilə yönləndir
  };

  useEffect(() => {
    dispatch(fetchTours()); // API-dən turları çək
    dispatch(fetchBlogs());
  }, [dispatch]);

  useEffect(() => {
    setTourList(tours); // API-dən gələn turları state-ə yaz
  }, [tours]);

  // Sola sürüşdürmə funksiyası
  const prevSlide = () => {
    if (tourList.length > 1) {
      const lastTour = tourList[tourList.length - 1]; // Sonuncu elementi götür
      const newTourList = [lastTour, ...tourList.slice(0, -1)]; // Sonuncunu başa qoy, digərlərini saxla
      setTourList(newTourList);
    }
  };

  // Sağa sürüşdürmə funksiyası
  const nextSlide = () => {
    if (tourList.length > 1) {
      const firstTour = tourList[0]; // İlk elementi götür
      const newTourList = [...tourList.slice(1), firstTour]; // İlk elementi sona qoy
      setTourList(newTourList);
    }
  };

  if (status === "loading") {
    return <Loading />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <main>
        <FollowUs />
        <section className="hero">
          <div className="texts-div">
            <h3>{translation[currentLang].heroh3}</h3>
            <h1
              dangerouslySetInnerHTML={{
                __html: translation[currentLang].heroh1,
              }}
            ></h1>
            <p
              dangerouslySetInnerHTML={{
                __html: translation[currentLang].herop,
              }}
            ></p>
          </div>
          <img className="hero-image" src={model} alt="model" />
        </section>

        <section className="company-hero">
          <div className="cards-div">
            <div className="first-cards-div">
              <div className="card">
                <img src={airplane} alt="" />
                <h5>24,000</h5>
                <p>{translation[currentLang].companyhomecard1}</p>
              </div>
              <div className="card">
                <img src={bestprice} alt="" />
                <h5>Best price</h5>
                <p>{translation[currentLang].companyhomecard2}</p>
              </div>
            </div>
            <div className="second-cards-div">
              <div className="card">
                <img src={navigation} alt="" />
                <h5>55+</h5>
                <p>{translation[currentLang].companyhomecard3}</p>
              </div>
              <div className="card">
                <img src={employee} alt="" />
                <h5>84 Million+</h5>
                <p>{translation[currentLang].companyhomecard4}</p>
              </div>
            </div>
          </div>
          <div className="texts-div">
            <h2
              dangerouslySetInnerHTML={{
                __html: translation[currentLang].companyh2,
              }}
            ></h2>
            <p
              dangerouslySetInnerHTML={{
                __html: translation[currentLang].companyp,
              }}
            ></p>
          </div>
        </section>

        <section className="active-tours-section">
          <div className="line-div">
            <hr />
            {translation[currentLang].activetourhr}
            <hr />
          </div>

          <div className="tours-list-div">
            <div className="head">
              <h1
                dangerouslySetInnerHTML={{
                  __html: translation[currentLang].activetourlisth1,
                }}
              ></h1>
              <NavLink
                dangerouslySetInnerHTML={{
                  __html: translation[currentLang].activetourlista,
                }}
                to={`/${currentLang}/alltours`}
              ></NavLink>
            </div>

            <div className="lists">
              <ul>
                <ImageSlider tours={tourList}></ImageSlider>
              </ul>
            </div>
          </div>
        </section>

        <section className="blog-section">
          <div className="line-div">
            <hr />
            {translation[currentLang].blogsectionhr}
            <hr />
          </div>

          <div className="lists">
            <h1>Blog</h1>
            <h2
              dangerouslySetInnerHTML={{
                __html: translation[currentLang].bloglisth2,
              }}
            ></h2>

            <ul>
              {blogs.map((blog) => {
                return (
                  <li style={{ cursor: "pointer" }}>
                    <Link to={`/${currentLang}/blog/${blog.id}`}>
                      <div
                        style={{
                          backgroundImage: `url(${blog.headerImageUrl}`,
                        }}
                        className="blog-card"
                      >
                        <h3>{blog.title}</h3>
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>

        <section className="experience-section">
          <div className="head">
            <h1>Təcrübə</h1>
            <h2>#joyfultravel</h2>
          </div>

          <ul>
            <li>
              <div className="instagram-card">
                <h2 className="start">@muradsadikhov</h2>
                <h2 className="end">Exploring the world with a happy heart</h2>
              </div>
            </li>
            <li>
              <div className="instagram-card">
                <h2 className="start">@muradsadikhov</h2>
                <h2 className="end">Exploring the world with a happy heart</h2>
              </div>
            </li>
            <li>
              <div className="instagram-card">
                <h2 className="start">@muradsadikhov</h2>
                <h2 className="end">Exploring the world with a happy heart</h2>
              </div>
            </li>
            <li>
              <div className="instagram-card">
                <h2 className="start">@muradsadikhov</h2>
                <h2 className="end">Exploring the world with a happy heart</h2>
              </div>
            </li>
            <li>
              <div className="instagram-card">
                <h2 className="start">@muradsadikhov</h2>
                <h2 className="end">Exploring the world with a happy heart</h2>
              </div>
            </li>
          </ul>
        </section>

        <section className="aboutus-section">
          <div className="line-div">
            <hr />
            Məlumat
            <hr />
          </div>

          <div className="head">
            <h1>Haqqımızda</h1>
            <h2>NİYƏ BİZ ?</h2>
          </div>

          <div className="aboutus-body">
            <div className="aboutus-cards-div">
              <div className="first-card-div">
                <div className="circle"></div>
                <img src={travel} alt="travelleft" />
              </div>
              <div className="second-card-div">
                <img className="logo-img" src={logotransparent} alt="" />
                <div className="circle"></div>
                <img className="travel-img" src={travel} alt="travelleft" />
              </div>
            </div>

            <div className="aboutus-texts-div">
              <h1
                dangerouslySetInnerHTML={{
                  __html: translation[currentLang].homeaboutusheadertext,
                }}
                className="header-text"
              ></h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: translation[currentLang].homeaboutusheaderparagraph,
                }}
                className="header-paragraph"
              ></p>

              <hr />
              <ul>
                <li>
                  <img src={diversity} alt="diversity" />
                  <div className="text-div">
                    <h1>{translation[currentLang].homeaboutuslist1h1}</h1>
                    <p>{translation[currentLang].homeaboutuslist1p}</p>
                  </div>
                </li>
                <li>
                  <img src={universal} alt="diversity" />
                  <div className="text-div">
                    <h1>{translation[currentLang].homeaboutuslist2h1}</h1>
                    <p>{translation[currentLang].homeaboutuslist2p}</p>
                  </div>
                </li>
                <li>
                  <img src={confidence} alt="diversity" />
                  <div className="text-div">
                    <h1>{translation[currentLang].homeaboutuslist2h1}</h1>
                    <p>{translation[currentLang].homeaboutuslist2p}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
